import { AppCookies } from '@enums/cookies';

export type BannerSize = 'big' | 'small';
export const BANNER_SIZE = {
  BIG: 'big',
  SMALL: 'small',
} as const;

export type BannerType =
  | 'app_general_big'
  | 'app_general_promo_big'
  | 'commercial_precise_fallback'
  | 'commercial_precise'
  | 'commercial_vague'
  | 'better_experience'
  | 'stars_only'
  | 'control';

export const BANNER_TYPE = {
  APP_GENERAL_BIG: 'app_general_big',
  APP_GENERAL_PROMO_BIG: 'app_general_promo_big',
  COMMERCIAL_PRECISE_FALLBACK: 'commercial_precise_fallback',
  COMMERCIAL_PRECISE: 'commercial_precise',
  COMMERCIAL_VAGUE: 'commercial_vague',
  BETTER_EXPERIENCE: 'better_experience',
  STARS_ONLY: 'stars_only',
  CONTROL: 'control',
} as const;

export type BannerState = {
  isClosed: boolean;
  closedAt: number | null;
};

export type BannerVisibilityState = {
  show: boolean;
  variant: BannerSize | null;
};

export type BannerTextsType = {
  title: string;
  content: string;
  cta: string;
  link: string;
};

export type BannerTextsListType = {
  [name: string]: BannerTextsType;
};

export const BANNER_COOKIES = {
  [BANNER_SIZE.BIG]: AppCookies.BIG_SMART_BANNER_CLOSED,
  [BANNER_SIZE.SMALL]: AppCookies.SMALL_SMART_BANNER_CLOSED,
} as const;

export const BANNER_TIMINGS = {
  [BANNER_SIZE.BIG]: {
    cooldown: 24 * 60 * 60 * 1000,
    expiry: 0,
  },
  [BANNER_SIZE.SMALL]: {
    cooldown: 0,
    expiry: 24 * 60 * 60 * 1000,
  },
} as const;

export const BANNER_CONFIG = {
  COOKIES: BANNER_COOKIES,
  TIMINGS: BANNER_TIMINGS,
  VARIANTS: {
    ENABLED: [BANNER_SIZE.BIG, BANNER_SIZE.SMALL] as const,
    ORDER: [BANNER_SIZE.BIG, BANNER_SIZE.SMALL] as const,
  },
} as const;

export const NO_OF_STARS = 5;
export const IOS_RATING_LABEL = '(45k)';
export const ANDROID_RATING_LABEL = '(22k)';

export const ADJUST_LINK_BASES: Record<string, string> = {
  control: 'https://wj62.adj.st/action?type=start&adj_t=pjs36go_5kli5il',
  better_experience: 'https://wj62.adj.st/action?type=start&adj_t=12v7j4ie_12jifi3e',
  commercial_precise: 'https://wj62.adj.st/action?type=start&adj_t=126tzp0b_12rumddw',
  commercial_precise_fallback: 'https://wj62.adj.st/action?type=start&adj_t=126tzp0b_12rumddw',
  commercial_vague: 'https://wj62.adj.st/action?type=start&adj_t=136p2qq5_13zilkwe',
  stars_only: 'https://wj62.adj.st/action?type=start&adj_t=12grmoub_12s3r2ym',
};

export const PAGETYPE_VARIANTS: Record<string, (voucherValid: boolean) => BannerType> = {
  HomePage: () => BANNER_TYPE.APP_GENERAL_BIG,
  CategoryPage: () => BANNER_TYPE.APP_GENERAL_BIG,
  ProductPage: (voucherValid) => (voucherValid ? BANNER_TYPE.APP_GENERAL_PROMO_BIG : BANNER_TYPE.APP_GENERAL_BIG),
  HeroPDPPage: (voucherValid) => (voucherValid ? BANNER_TYPE.APP_GENERAL_PROMO_BIG : BANNER_TYPE.APP_GENERAL_BIG),
};
